/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import { PayloadAction } from "@reduxjs/toolkit";
import { ILabelDeviceFilterState } from "../../types";
import { ILabelData} from "../../../api/devices/types";
import { IGeoRegion } from "../../../api/admin/types";
import { initialGeoRegion } from "../../../../components/helpers";

export const setLabelNameAction = (state: ILabelDeviceFilterState, action: PayloadAction<ILabelData | undefined>) => {
  state.labelName = action.payload;
};

export const setIsLabelDeviceAssociationProgressAction = (state: ILabelDeviceFilterState, action: PayloadAction<boolean>) => {
  state.isLabelDeviceAssociationProgress = action.payload;
};

export const setSiteGroupAction = (state: ILabelDeviceFilterState, action: PayloadAction<string>) => {
  state.siteGroup = action.payload;
};

export const setAddDeviceSiteGroupAction = (state: ILabelDeviceFilterState, action: PayloadAction<string>) => {
  state.addDeviceSiteGroup = action.payload;
};

export const setGeoRegionAction = (state: ILabelDeviceFilterState, action: PayloadAction<IGeoRegion>) => {
  state.geoRegion = action.payload;
};

export const setAddDeviceGeoRegionAction = (state: ILabelDeviceFilterState, action: PayloadAction<IGeoRegion>) => {
  state.addDeviceGeoRegion = action.payload;
};

export const setIsAssociatedDevicesRemovedAction = (state: ILabelDeviceFilterState, action: PayloadAction<boolean>) => {
  state.isAssociatedDevicesRemoved = action.payload;
};

export const resetFiltersAction = (state: ILabelDeviceFilterState) => {
  state.geoRegion = initialGeoRegion;
  state.siteGroup = "";
};

export const resetAddDeviceFiltersAction = (state: ILabelDeviceFilterState) => {
  state.addDeviceGeoRegion = initialGeoRegion;
  state.addDeviceSiteGroup = "";
};